import { HttpErrorResponse } from '@angular/common/http';
import { ValvurApiErrorBody } from './valvur-api-error.model';

/** Normalized API failure thrown from `ErrorInterceptor`. */
export class ValvurHttpError extends Error {
  override readonly name = 'ValvurHttpError';

  readonly statusCode: number;
  readonly errorCode: string;

  constructor(
    readonly apiError: ValvurApiErrorBody,
    readonly original: HttpErrorResponse,
  ) {
    super(apiError.message);
    this.statusCode = apiError.statusCode;
    this.errorCode = apiError.errorCode;
  }
}

export function isValvurHttpError(error: unknown): error is ValvurHttpError {
  return error instanceof ValvurHttpError;
}
